import { DisplayDate, DisplayTime } from '@tock/time';
import { detectUserTimeZoneName } from 'state/app';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  dateTimeEpochMillis: number;
}

export default class NextReleaseDateTime extends PureBaseComponent<Props> {
  render() {
    const { dateTimeEpochMillis } = this.props;
    const timeZone = detectUserTimeZoneName();
    const date = new Date(dateTimeEpochMillis);
    return (
      <span>
        <DisplayDate dateValue={date} displayMonthAs="long" /> at <DisplayTime timeValue={date} />
        &nbsp;
        {timeZone}.
      </span>
    );
  }
}
